// DO NOT EDIT -- generated from Go package fs/corp/shortcut

import * as time from './time';


///////////
// Enums //
///////////

export enum StoryType {
	STBug = "bug",
	STChore = "chore",
	STFeature = "feature",
	STInvalid = ""
}


/////////////
// Structs //
/////////////

export interface ThreadedComment {
  app_url: string;
  author_id: string;
  comments: Array<ThreadedComment | null> | null;
  created_at: time.Time | null;
  deleted: boolean;
  entity_type: string;
  external_id: string;
  group_mention_ids: string[] | null;
  id: number;
  member_mention_ids: string[] | null;
  mention_ids: string[] | null;
  text: string;
  updated_at: time.Time | null;
}

// LabelSlim is the same as a Label except it doesn't aggregate stats
// E.g. a request for a story will return Labels []LabelSlim - you can then gather the stats
// by using the ID of the LabelSlim to get the full Label
export interface LabelSlim {
  app_url: string;
  archived: boolean;
  color: string;
  created_at: time.Time | null;
  description: string;
  entity_type: string;
  external_id: string;
  id: number;
  name: string;
  updated_at: time.Time | null;
}

export interface EpicStats {
  average_cycle_time: number;
  average_lead_time: number;
  last_story_update: time.Time | null;
  num_points: number;
  num_points_done: number;
  num_points_started: number;
  num_points_unstarted: number;
  num_related_documents: number;
  num_stories_done: number;
  num_stories_started: number;
  numstories_total: number;
  num_stories_unestimated: number;
  num_stories_unstarted: number;
}

export interface Epic {
  app_url: string;
  archived: boolean;
  comments: Array<ThreadedComment | null> | null;
  completed: boolean;
  completed_at: time.Time | null;
  completed_at_override: time.Time | null;
  created_at: time.Time | null;
  deadline: time.Time | null;
  description: string;
  entity_type: string;
  epic_state_id: number;
  external_id: string;
  follower_ids: string[] | null;
  group_id: string;
  group_mention_ids: string[] | null;
  id: number;
  labels: Array<LabelSlim | null> | null;
  member_mention_ids: string[] | null;
  mention_ids: string[] | null;
  milestone_id: number;
  name: string;
  owner_ids: string[] | null;
  planned_start_date: time.Time | null;
  position: number;
  productboard_id: string;
  productboard_plugin_id: string;
  productboard_url: string;
  project_ids: number[] | null;
  request_by_id: string;
  started_at: time.Time | null;
  started_at_over_ride: time.Time | null;
  state: string;
  stats: EpicStats | null;
  updated_at: time.Time | null;
}

export interface Icon {
  created_at: time.Time | null;
  entity_type: string;
  id: string;
  updated_at: time.Time | null;
  url: string;
}

export interface Group {
  app_url: string;
  archived: boolean;
  color: string;
  description: string;
  display_icon: Icon | null;
  entity_type: string;
  id: string;
  member_ids: string[] | null;
  mention_name: string;
  name: string;
  num_epics_started: number;
  num_stories: number;
  num_stories_started: number;
}

export interface PullRequestLabel {
  color: string;
  description: string;
  entity_type: string;
  id: number;
  name: string;
}

export interface PullRequest {
  branch_id: number;
  branch_name: string;
  build_status: string;
  closed: boolean;
  created_at: time.Time | null;
  draft: boolean;
  entity_type: string;
  id: number;
  merged: boolean;
  num_added: number;
  num_commits: number;
  num_modified: number;
  num_removed: number;
  number: number;
  repository_id: number;
  review_status: string;
  target_branch_id: number;
  target_branch_name: string;
  title: string;
  updated_at: time.Time | null;
  url: string;
  vcs_labels: Array<PullRequestLabel | null> | null;
}

export interface Branch {
  created_at: time.Time | null;
  deleted: boolean;
  entity_type: string;
  id: number;
  merged_branch_ids: number[] | null;
  name: string;
  persistent: boolean;
  pull_requests: Array<PullRequest | null> | null;
  repository_id: number;
  updated_at: time.Time | null;
  url: string;
}

export interface Comment {
  app_url: string;
  author_id: string;
  created_at: time.Time | null;
  entity_type: string;
  external_id: string;
  group_mention_ids: string[] | null;
  id: number;
  member_mention_ids: string[] | null;
  mention_ids: string[] | null;
  position: number;
  story_id: number;
  text: string;
  updated_at: time.Time | null;
}

export interface Identity {
  entity_type: string;
  name: string;
  type: string;
}

export interface Commit {
  author_email: string;
  author_id: string;
  author_identity: Identity | null;
  created_at: time.Time | null;
  entity_type: string;
  hash: string;
  id: number;
  merged_branch_ids: number[] | null;
  message: string;
  repository_id: number;
  timestamp: time.Time | null;
  updated_at: time.Time | null;
  url: string;
}

export interface File {
  content_type: string;
  created_at: time.Time | null;
  description: string;
  entity_type: string;
  external_id: string;
  filename: string;
  group_mention_ids: string[] | null;
  id: number;
  member_mention_ids: string[] | null;
  mention_ids: string[] | null;
  name: string;
  size: number;
  story_ids: number[] | null;
  thumbnail_url: string;
  updated_at: time.Time | null;
  uploader_id: string;
  url: string;
}

export interface LinkedFile {
  content_type: string;
  created_at: time.Time | null;
  description: string;
  entity_type: string;
  group_mention_ids: string[] | null;
  id: number;
  member_mention_ids: string[] | null;
  mention_ids: string[] | null;
  name: string;
  size: number;
  story_ids: number[] | null;
  thumbnail_url: string;
  type: string;
  updated_at: time.Time | null;
  uploader_id: string;
  url: string;
}

export interface StoryStats {
  num_related_documents: number;
}

export interface TypedStoryLink {
  created_at: time.Time | null;
  entity_type: string;
  id: number;
  object_id: number;
  subject_id: number;
  type: string;
  updated_at: time.Time | null;
  verb: string;
}

export interface Task {
  complete: boolean;
  completed_at: time.Time | null;
  created_at: time.Time | null;
  description: string;
  entity_type: string;
  external_id: string;
  group_mention_ids: string[] | null;
  id: number;
  member_mention_ids: string[] | null;
  mention_ids: string[] | null;
  owner_ids: string[] | null;
  position: number;
  story_id: number;
  updated_at: time.Time | null;
}

export interface Story {
  app_url: string;
  archived: boolean;
  blocked: boolean;
  blocker: boolean;
  branches: Array<Branch | null> | null;
  comments: Array<Comment | null> | null;
  commits: Array<Commit | null> | null;
  completed: boolean;
  completed_at: time.Time | null;
  completed_at_override: time.Time | null;
  created_at: time.Time | null;
  deadline: time.Time | null;
  description: string;
  entity_type: string;
  epic_id: number;
  estimate: number;
  external_id: string;
  external_links: string[] | null;
  files: Array<File | null> | null;
  follower_ids: string[] | null;
  id: number;
  iteration_id: number;
  labels: Array<LabelSlim | null> | null;
  lead_time: number;
  linked_files: Array<LinkedFile | null> | null;
  member_mention_ids: string[] | null;
  mention_ids: string[] | null;
  moved_at: time.Time | null;
  name: string;
  owner_ids: string[] | null;
  position: number;
  previous_iteration_ids: number[] | null;
  project_id: number;
  pull_requests: Array<PullRequest | null> | null;
  requested_by_id: string;
  started: boolean;
  started_at: time.Time | null;
  started_at_override: time.Time | null;
  stats: StoryStats | null;
  story_links: Array<TypedStoryLink | null> | null;
  story_type: StoryType;
  tasks: Array<Task | null> | null;
  updated_at: time.Time | null;
  workflow_id: number;
  worflow_state_id: number;
}

export interface CreateStoryCommentParams {
  author_id?: string;
  created_at?: time.Time | null;
  external_id?: string;
  text?: string;
  updated_at: time.Time | null;
}

export interface CreateLabelParams {
  color?: string;
  description?: string;
  external_id?: string;
  name?: string;
}

export interface CreateStoryLinkParams {
  object_id?: number;
  subject_id?: number;
  verb?: string;
}

export interface CreateTaskParams {
  complete?: boolean;
  created_at?: time.Time | null;
  description?: string;
  external_id?: string;
  owner_ids?: string[] | null;
  updated_at?: time.Time | null;
}

export interface CreateStoryParams {
  archived?: boolean;
  comments?: Array<CreateStoryCommentParams | null> | null;
  completed_at_override?: time.Time | null;
  created_at?: time.Time | null;
  deadline?: time.Time | null;
  description?: string;
  epic_id?: number;
  estimate?: number;
  external_id?: string;
  external_links?: string[] | null;
  file_ids?: number[] | null;
  follower_ids?: string[] | null;
  group_id?: string;
  iteration_id?: string;
  labels?: Array<CreateLabelParams | null> | null;
  linked_file_ids?: number[] | null;
  name?: string;
  owner_ids?: string[] | null;
  project_id?: number;
  requested_by_id?: string;
  started_at_override?: time.Time | null;
  story_links?: Array<CreateStoryLinkParams | null> | null;
  story_type?: StoryType;
  tasks?: Array<CreateTaskParams | null> | null;
  updated_at?: time.Time | null;
  workflow_state_id?: number;
}

// ClubhouseTypes is just a placeholder into which we
// add all the types defined in the shortcut package so they can be exported to TS.
export interface ClubhouseTypes {
  F1: Epic | null;
  F2: Group | null;
  F3: Story | null;
  F4: CreateStoryParams | null;
  F5: CreateLabelParams | null;
}
